import Vue, { VNode } from 'vue';

export function findVueNodeByComponent(nodes: Array<VNode>, component: typeof Vue): VNode | null {
  return nodes.find((node) => node.componentOptions?.Ctor === component) || null;
}
